import { render } from "./outboundCallRecords.vue?vue&type=template&id=bfdf6df4&scoped=true"
import script from "./outboundCallRecords.vue?vue&type=script&lang=js"
export * from "./outboundCallRecords.vue?vue&type=script&lang=js"

import "./outboundCallRecords.vue?vue&type=style&index=0&id=bfdf6df4&scoped=true&lang=css"
import "./outboundCallRecords.vue?vue&type=style&index=1&id=bfdf6df4&lang=css"
script.render = render
script.__scopeId = "data-v-bfdf6df4"

export default script